import { QueryClient } from "@tanstack/react-query";

// Singleton QueryClient instance for use outside React components
// This allows cache invalidation from utility functions and service methods
let globalQueryClient: QueryClient | null = null;

export function setGlobalQueryClient(client: QueryClient) {
  globalQueryClient = client;
}

export function getGlobalQueryClient(): QueryClient | null {
  return globalQueryClient;
}

/**
 * Invalidate all booking-related queries across the application
 * Call this after any booking mutation (create, update, delete, cancel)
 *
 * Note: "bookings" (plural) covers list/calendar queries.
 * "booking" (singular) covers individual booking detail queries.
 * Both must be invalidated to ensure all views reflect changes.
 * "occurrence-amenities" covers the R27 per-date amenity lists (Manage series chips, Custom badges,
 * Reset enablement) — exclusions, holidays, datetime and whole-series amenity changes all alter them.
 */
export async function invalidateBookingQueries() {
  if (globalQueryClient) {
    await Promise.all([
      globalQueryClient.invalidateQueries({ queryKey: ["bookings"] }),
      globalQueryClient.invalidateQueries({ queryKey: ["booking"] }),
      globalQueryClient.invalidateQueries({ queryKey: ["occurrence-amenities"] }),
    ]);
  }
}
